import { getProviderContactPhone } from '@kyruus/provider-components';
import { PMCConfig } from '@kyruus/types';
import { ExtendedProvider } from 'Src/types';
import { DefaultCtaListItems } from './constants';
import { looksLikeInternalBookingUrl } from 'Src/utils/url';

const shouldRenderBookOnline = (
  config: PMCConfig,
  provider: ExtendedProvider
): boolean => {
  const modalConfig = config.modal_display ?? {};
  const isBookOnlineItemEnabled = Boolean(modalConfig.book_online);
  const hasBookOnlineUrl = Boolean(provider.book_online_url);
  if (!isBookOnlineItemEnabled || !hasBookOnlineUrl) {
    return false;
  }
  const isExternalBookOnlineUrl = !looksLikeInternalBookingUrl(
    provider.book_online_url
  );
  // Do not consider availability for external booking
  if (isExternalBookOnlineUrl) {
    return true;
  }
  const providerHasAvailability = provider.has_provider_availability;
  if (providerHasAvailability) {
    return true;
  }
  return false;
};

export const getCtaListItemsToDisplay = (
  config: PMCConfig,
  provider: ExtendedProvider
): DefaultCtaListItems[] => {
  const listItemsToDisplay = [];
  const modalConfig = config.modal_display ?? {};

  if (shouldRenderBookOnline(config, provider)) {
    listItemsToDisplay.push(DefaultCtaListItems.BookOnline);
  }

  const phoneEnabled = modalConfig.provider_phone ?? false;
  const providerPhone = getProviderContactPhone(provider);
  if (phoneEnabled && providerPhone) {
    listItemsToDisplay.push(DefaultCtaListItems.Phone);
  }

  const requestFormEnabled = modalConfig.appointment_request_form ?? false;
  const providerHasRequestForm = Boolean(provider.request_appointment_url);
  if (requestFormEnabled && providerHasRequestForm) {
    listItemsToDisplay.push(DefaultCtaListItems.RequestForm);
  }

  const virtualCareEnabled = modalConfig.virtual_care ?? false;
  const providerHasVirtualCareUrl = Boolean(provider.virtual_care_url);
  if (providerHasVirtualCareUrl && virtualCareEnabled) {
    listItemsToDisplay.push(DefaultCtaListItems.VirtualCare);
  }
  return listItemsToDisplay;
};
